import { User } from "@auth/auth.interfaces";
import { TokenService } from "@auth/token.service";
import { environment } from "@env/environment";
import { ToastrService } from "ngx-toastr";

export function isPresent(obj: any): boolean {
  return obj !== undefined && obj !== null;
}

export function isDate(obj: any): boolean {
  return !/Invalid|NaN/.test(new Date(obj).toString());
}

export function showToastr(
  toastr: ToastrService,
  message: string,
  type: "success" | "error" | "info" | "warning"
) {
  let toastClass = "";
  let timeOut = 5 * 1000;
  let config = {
    timeOut: timeOut,
    enableHtml: true,
    closeButton: true,
    progressBar: true,
    toastClass: toastClass,
  };

  switch (type) {
    case "success":
      config = { ...config, toastClass: "alert alert-success" };
      toastr.success(message, "", config);
      logger(message, "log");
      break;

    case "error":
      config = {
        ...config,
        toastClass: "alert alert-danger alert-with-icon",
        timeOut: 10 * 1000,
      };
      toastr.error(message, "", config);
      logger(message, "error");
      break;

    case "info":
      config = { ...config, toastClass: "alert alert-info" };
      toastr.info(message, "", config);
      logger(message, "info");
      break;

    case "warning":
      config = { ...config, toastClass: "alert alert-warning" };
      toastr.warning(message, "", config);
      logger(message, "warn");
      break;
  }
}

export const ROLES = {
  COMPRAS: "COMPRAS",
  OFERENTE: "OFERENTE",
  DIRECTOR: "DIRECTOR",
  PERITO: "PERITO",
  CONFIGURACION: "CONFIGURACION",
  RECEPCION: "RECEPCION",
  ASISTENCIA_CALLCENTER: "ASISTENCIA_CALLCENTER",
  ASISTENCIA_COMPRA: "ASISTENCIA_COMPRA",
  CONFIRMACIONASISTENCIA: "CONFIRMACIONASISTENCIA",
  PRESENTACION: "PRESENTACION",
};

export function canActivateByRole(decodeToken: {}, rol: string): boolean {
  const roles =
    decodeToken["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];

  if (Array.isArray(roles)) return roles.includes(rol);
  return roles == rol;
}

export function canActivateGuard(
  tokenService: TokenService,
  user: Partial<User>,
  role: string
): boolean {
  try {
    if (user && !tokenService.isTokenExpired(user.AccessToken)) {
      return canActivateByRole(
        tokenService.decodeToken(user.AccessToken),
        role
      );
    }
  } catch (error) {
    return false;
  }
}

export function redirectTo({ Menu }): string {
  if (Menu && Menu.length > 0) return Menu[0].Url;

  throw Error("Este usuario no posee ningun menu asignado");
}

export function isInvalidEmail(mail: string) {
  if (
    !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
      mail
    )
  ) {
    return true;
  }
  return false;
}

export function logger(
  message: any,
  type: "log" | "warn" | "error" | "info" | "dir" | "table" = "info"
) {
  if (environment.production) return;

  switch (type) {
    case "log":
      console.log(message);
      break;

    case "warn":
      console.warn(message);
      break;

    case "error":
      console.error(message);
      break;

    case "info":
      console.info(message);
      break;

    case "dir":
      console.dir(message);
      break;

    case "table":
      console.table(message);
      break;
  }
}
